import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FindWorkSection() {
  return <section className="py-24 px-6 md:px-12 bg-white" data-id="element-46">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-47">
        {/* Image with offset border */}
        <div className="relative pl-6 pb-6" data-id="element-48">
          {/* Blue offset border (bottom left) */}
          <div className="absolute bottom-0 left-0 w-[90%] h-[90%] border-8 border-primary z-0" data-id="element-49"></div>
          <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=1000&auto=format&fit=crop" alt="Welder working" className="relative z-10 w-full h-[500px] object-cover shadow-xl" data-id="element-50" />
        </div>

        {/* Content */}
        <div data-id="element-51">
          <div className="section-badge" data-id="element-52">FIND JOBS TODAY</div>
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-6 leading-tight" data-id="element-53">
            FIND WORK THAT MOVES YOUR CAREER FORWARD
          </h2>
          <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-54">
            We partner with the Gulf Coast's top industrial and commercial
            contractors to connect skilled craftsmen with rewarding
            opportunities. Whether you're a seasoned professional or looking to
            advance your career, we provide the support and placements you need
            to succeed.
          </p>
          <button className="btn-white border border-gray-200 shadow-sm w-fit group" data-id="element-55">
            VIEW ALL JOBS
            <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-56">
              <ArrowRight size={16} data-id="element-57" />
            </div>
          </button>
        </div>
      </div>
    </section>;
}